// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2UsvH","wrapper-nopadding":"wrapper-nopadding__2c7YN","loading":"loading__2Aw0k","error":"error__r-Pud","table-loading":"table-loading__MYBcz","empty-val":"empty-val__1S64d","panelheader-tools":"panelheader-tools__9ZjpU","propsPanels":"propsPanels__2jZJi","new":"new__3hXCJ","marginLm":"marginLm__fArYb","marginRm":"marginRm__3SpZj","fullWidth":"fullWidth__WFCRV","fullHeight":"fullHeight__20K_Z","noData":"noData__cFJOo","view":"view__3o0fY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/styles.scss
// module id = 2275
// module chunks = 1